var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7,
    cy: 18.7,
    r: 18.7,
    fill: "#EDEEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9811 30.6052C26.4204 30.6052 30.605 26.4206 30.605 18.9813C30.605 11.542 26.4204 7.35742 18.9811 7.35742C11.5418 7.35742 7.35718 11.542 7.35718 18.9813C7.35718 26.4206 11.5418 30.6052 18.9811 30.6052Z",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3915 21.5632C14.223 23.7025 16.149 24.8667 18.9806 24.8667C21.8122 24.8667 23.7382 23.7025 24.5697 21.5632",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.722 16.2986C13.0574 15.7537 13.795 15.4044 14.5103 15.4044C15.2257 15.4044 15.9633 15.7537 16.2986 16.2986",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7493 16.2986C22.0846 15.7537 22.8222 15.4044 23.5376 15.4044C24.2529 15.4044 24.9905 15.7537 25.3259 16.2986",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile1);
export default __webpack_public_path__ + "static/media/smile-1.feaeed3b98aff7c4f2d3665aa2accb66.svg";
export { ForwardRef as ReactComponent };